<script>
import { reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import { routeTo } from "@/utils"
import SrUpload from '@/components/SrUpload/index'
import { getBusinessInfo, updateBusinessInfo, addBusinessInfo } from "@/api/modules/auth"
import { vab } from "@libs/utils"
import { useI18n } from "@/plugins/i18n"

export default {
  components: { SrUpload },
  setup() {
    // form相关代码
    const { formReq, loadingScope, formRules } = handleForm()
    const store = useStore()
    const { t } = useI18n()
    const { FILE } = store.state.base.constant
    const refs = reactive({ formRef: null, certRef: null })
    const stepComplete = computed(() => store.state.auth.registerInfo.stepComplete)

    // 上一步
    const handlePrev = () => {
      routeTo('/auth/personal/register')
    }

    // 处理下一步
    const handleNext = () => {
      refs.formRef.validate(async (valid) => {
        if (valid) {
          loadingScope.btnLoading = true
          try {
            const { employmentInfo, recoCustomerInfo, otherMaterials: { otherMaterialFileId }, regId, addFlag } = formReq
            const param = { employmentInfo, recoCustomerInfo, otherMaterialFileId }
            addFlag ? await updateBusinessInfo({ ...param, regId }) : addBusinessInfo({ ...param, regId })
            routeTo('/auth/personal/overview')
            loadingScope.btnLoading = false
          } catch (err) {
            loadingScope.btnLoading = false
          }
        }
      })
    }
    return {
      FILE,
      formReq,
      formRules,
      t,
      ...toRefs(refs),
      ...toRefs(loadingScope),
      handleNext,
      handlePrev,
    }
  }
}

// 处理表单相关
const handleForm = () => {
  const { t } = useI18n()
  // loading 相关
  const loadingScope = reactive({
    pageLoading: false,
    btnLoading: false
  })

  const store = useStore()

  // 请求参数相关
  const formReq = reactive({
    employmentInfo: '',
    recoCustomerInfo: '',
    otherMaterials: {
      otherMaterialFileId: '',
      otherMaterialName: '',
    }
  })

  // 表单规则相关
  const formRules = reactive({
    employmentInfo: [
      { required: true, message: t('auth.company.business.error.text_1'), trigger: 'blur' }
    ],
    recoCustomerInfo: [
      { required: true, message: t('auth.company.business.error.text_2'), trigger: 'blur' }
    ]
  })

  const initData = async () => {
    loadingScope.pageLoading = true
    try {
      const res = await getBusinessInfo()
      store.dispatch('auth/setStep')
      formReq.regId = res.regId
      formReq.employmentInfo = res.employmentInfo
      formReq.recoCustomerInfo = res.recoCustomerInfo
      formReq.otherMaterials.otherMaterialFileId = res.otherMaterialFileId
      loadingScope.pageLoading = false
      formReq.addFlag = !!res.employmentInfo
    } catch {
      loadingScope.pageLoading = false
    }
  }

  initData()

  return { formReq, loadingScope, formRules }
}
</script>

<template>
  <div class="auth-business-info-container">
    <el-form
        :model="formReq"
        :rules="formRules"
        ref="formRef"
        :label-width="localCN?'150px':'230px'"
        label-position="left"
        v-loading="pageLoading">
      <el-row>
        <el-col :span="24">
          <div class="h1">{{t('auth.company.business.title.text_1')}}</div>
          <!--从业信息简介-->
          <el-form-item prop="employmentInfo" :label="t('auth.company.business.label.text_1')">
            <el-input :placeholder="t('auth.company.business.content.text_1')" :rows="5" type="textarea" v-model="formReq.employmentInfo"/>
          </el-form-item>
          <!--主要推荐客户类型-->
          <el-form-item prop="recoCustomerInfo" :label="t('auth.company.business.label.text_2')">
            <el-input :placeholder="t('auth.company.business.content.text_2')" :rows="5" type="textarea" v-model="formReq.recoCustomerInfo"/>
          </el-form-item>
          <!--其他材料-->
          <el-form-item prop="otherMaterialFileId" :label="t('auth.company.business.label.text_3')">
            <el-row>
              <el-col :span="24">
                <div class="h2">
                  {{t('auth.company.business.content.text_6')}}
                </div>
              </el-col>
              <el-col :span="24">
                <sr-upload
                    v-model:fileId="formReq.otherMaterials.otherMaterialFileId"
                    v-model:fileName="formReq.otherMaterials.otherMaterialName"
                    :filePrefix="FILE.PREFIX.OTHER_MATERIAL"
                    fileSize="5"
                    fileType=".jpg,.jpeg,.png,.bmp,.pdf,.zip"
                    :uploadDesc="t('auth.company.business.placeholder.text_1')"
                    :mode="FILE.UPLOAD_MODE.EDITABLE"/>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <el-button
                class="el-button__prev"
                @click="handlePrev">{{t('auth.company.business.content.text_5')}}
            </el-button>
            <el-button
                class="el-button__next"
                type="primary"
                v-loading="btnLoading"
                :disabled="btnLoading"
                @click="handleNext">{{t('auth.company.business.content.text_4')}}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<style scoped lang="scss">
  :deep(.el-form-item__content) {
    flex: inherit;

    .el-input__inner, .el-textarea__inner {
      width: 360px !important;
      border-radius: 4px !important;
    }
  }
</style>
